import { Injectable } from '@angular/core';
import { Http, Wrapper } from '@skylab-angular-shared/core';
import { SaleStatusesNotificatorBase } from '@skylab-shared/business';
import { EventNotificationsService } from '../event-notifications.service';

@Injectable({ providedIn: 'root'})
@Wrapper(SaleStatusesNotificatorBase)
export class SaleStatusesNotificator {
    public constructor(
        eventNortifications: EventNotificationsService,
        http: Http
    ) { }
}
